import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-observation-verification',
    templateUrl: './observation-verification.component.html',
    styleUrls: ['./observation-verification.component.scss'],
    standalone: false
})
export class ObservationVerificationComponent implements OnInit {
  accessCode: string = '';
  loading: boolean = false;
  verificationDetails: any = null;
  error: string = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(queryParams => {
      this.accessCode = queryParams['a'];
      if (this.accessCode) {
        this.verifyObservation();
      } else {
        this.error = 'Access code is required';
        this.showSnackBar('Access code is required', 'error');
      }
    });
  }

  verifyObservation(): void {
    this.loading = true;
    this.error = '';
    
    const url = `${environment.conciergeUrl}/concierge/api/v1/driver/verify-observation/${this.accessCode}`;
    this.http.get(url).subscribe({
      next: (response: any) => {
        this.loading = false;
        this.verificationDetails = response;
        console.log('Verification response:', response);
      },
      error: (error) => {
        this.loading = false;
        this.error = 'Failed to verify observation';
        console.error('Verification error:', error);
      }
    });
  }

  private showSnackBar(message: string, type: 'success' | 'error'): void {
    this.snackBar.open(message, 'Close', {
      duration: 3000,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      panelClass: type === 'success' ? ['success-snackbar'] : ['error-snackbar']
    });
  }

  retry(): void {
    this.verifyObservation();
  }

  getObjectKeys(obj: any): string[] {
    return obj ? Object.keys(obj) : [];
  }

  formatLabel(key: string): string {
    return key.replace(/([A-Z])/g, ' $1')
              .replace(/^./, str => str.toUpperCase())
              .trim();
  }

  formatDate(dateString: string): string {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      return date.toLocaleString('en-IN', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    } catch (error) {
      return dateString;
    }
  }

  isImageFile(filename: string): boolean {
    if (!filename) return false;
    const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg'];
    const extension = this.getFileExtension(filename).toLowerCase();
    return imageExtensions.includes(extension);
  }

  isVideoFile(filename: string): boolean {
    if (!filename) return false;
    const videoExtensions = ['.mp4', '.avi', '.mov', '.wmv', '.flv', '.webm', '.mkv'];
    const extension = this.getFileExtension(filename).toLowerCase();
    return videoExtensions.includes(extension);
  }

  getFileExtension(filename: string): string {
    if (!filename) return '';
    const lastDotIndex = filename.lastIndexOf('.');
    return lastDotIndex !== -1 ? filename.substring(lastDotIndex) : '';
  }

  openDocumentPreview(document: any): void {
    if (this.isImageFile(document.documentName)) {
      // Open image in new tab for full view
      window.open(document.documentUrl, '_blank');
    }
  }
}
